import { supabase } from '../supabase';

/**
 * Crea un'entità first-class del modello Contatti/Aziende:
 * persona (`individual`) o azienda (`company`), SENZA lifecycle
 * (stato_cliente/pipeline_id NULL → invariante referente, fuori dalla pipeline)
 * e SENZA side-effect (insert diretto, non passa da clientStore.createClient →
 * niente trigger workflow/newsletter). Vedi MD/architecture/contatti-aziende-firstclass-migrazione.md
 */
export async function createFirstClassEntity(
  organizationId: string,
  name: string,
  entityType: 'individual' | 'company',
  extra?: { email?: string | null; phone?: string | null },
): Promise<{ id: string; business_name: string } | null> {
  const clean = name.trim();
  if (!clean || !organizationId) return null;
  try {
    const { data, error } = await supabase
      .from('clients')
      .insert({
        organization_id: organizationId,
        business_name: clean,
        entity_type: entityType,
        email: extra?.email?.trim() || null,
        phone: extra?.phone?.trim() || null,
        stato_cliente: null,   // invariante: nessun lifecycle
        pipeline_id: null,
      })
      .select('id, business_name')
      .single();
    if (error) throw error;
    return data as { id: string; business_name: string };
  } catch {
    return null;
  }
}
